import React from 'react';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../constants/app';
import LazyImage from '../../ui-core/Image';
import { useWebsiteSettings } from '../../contexts/WebsiteSettingsContext';

const AboutJen = () => {
  const { websiteSettings, loading } = useWebsiteSettings();

  // Use API data if available, otherwise fall back to constants
  const aboutTitle =
    websiteSettings?.about_page_title || TEXT_CONSTANT.ABOUT_JEN_APP_TITLE;
  const aboutBody =
    websiteSettings?.about_page_description || TEXT_CONSTANT.ABOUT_JEN_APP_BODY;
  const aboutImage =
    websiteSettings?.about_page_image || IMAGE_CONSTANT.aboutJenHero;

  return (
    <div className="profile-form-div-outer">
      <div className="profile-form-div account-settings about-jen-page">
        <h2 className="account-settings-title">About Jen</h2>

        <div className="about-jen-hero">
          <LazyImage
            alt=""
            className="about-jen-hero-image"
            errorSrc={IMAGE_CONSTANT.MeetDocJenFit}
            placeholderSrc={IMAGE_CONSTANT.MeetDocJenFitLow}
            src={aboutImage}
          />
        </div>

        <div className="about-jen-app-section">
          <div className="about-jen-app-header">
            <div className="about-jen-app-logo" aria-hidden="true">
              <span>Jen</span>
            </div>
            <h3 className="about-jen-app-title">{aboutTitle}</h3>
          </div>
          <div
            className="about-jen-app-body"
            dangerouslySetInnerHTML={{ __html: aboutBody }}
          />
        </div>

        {loading && <div className="loading-indicator">Loading...</div>}
      </div>
    </div>
  );
};

export default AboutJen;
